import { createFileRoute } from '@tanstack/react-router';
import usePersonParams from '@/routes/_staff/person/$id/-hooks/usePersonParams';
import { LARGE_CATEGORY_CODES, SectionFormWrapper, prefetchPeopleLedgerDetail } from '@/routes/_staff/person/$id/_profile/-shared';
export const Route = createFileRoute('/_staff/person/alumni/$id/_profile/personal-information/')({
  component: PersonalInformation,
  loader: ({
    params
  }) => prefetchPeopleLedgerDetail(params.id, LARGE_CATEGORY_CODES.PERSONAL_INFORMATION)
});
function PersonalInformation() {
  const {
    id
  } = usePersonParams();
  return <SectionFormWrapper personId={id} largeCategoryCode={LARGE_CATEGORY_CODES.PERSONAL_INFORMATION} linkTo="/person/alumni/$id/personal-information" />;
}